import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWD503F1 (計劃/受訂託工單核准)
// ============================================================

export interface ApprovalCandidate {
  fd130_01: string; // 託工單號 (C7)
  fd130_11: string; // 託工日期 (D)
  fd130_12: string; // 加工廠名稱（已 Lookup）
  fd130_13: string; // 預定交期 (D)
  fd130_80: string; // 核准狀態碼：空=未核准，"P"=已完成
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwd503Api = {
  /** Query subcontract order candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwd503/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected subcontract orders */
  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwd503/approve', { items });
    return res.data;
  },
};
